import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.96 13.01a2.24 2.24 0 00-.25-.62 2.08 2.08 0 00-.34-.43l-9-8.42a2 2 0 00-2.74 0l-.17.16 7.27 6.8a3.58 3.58 0 01.69.87 4.04 4.04 0 01.5 1.23 4.47 4.47 0 01.08.82V29h2a1.9 1.9 0 001.28-.48 1.72 1.72 0 00.27-.27 1.98 1.98 0 00.41-.85A3.58 3.58 0 0030 27V13.42a1.84 1.84 0 00-.04-.41z"/><path d="M23.96 13.01a2.24 2.24 0 00-.25-.62 2.08 2.08 0 00-.34-.43l-9-8.42a2 2 0 00-2.74 0l-9 8.42a1.88 1.88 0 00-.46.66 1.98 1.98 0 00-.17.8V27a1.75 1.75 0 00.04.4 1.94 1.94 0 00.55 1.01 1.81 1.81 0 00.63.43A2.01 2.01 0 004 29h18a1.9 1.9 0 001.28-.48 1.72 1.72 0 00.27-.27 1.98 1.98 0 00.41-.85A3.58 3.58 0 0024 27V13.42a1.84 1.84 0 00-.04-.41zM11 27v-8h4v8zm11-.09l-.02.09H17v-8a2 2 0 00-2-2h-4a2 2 0 00-2 2v7.99H4V13.43l.01-.02 8.98-8.4A.01.01 0 0113 5l8.98 8.4.01.01a.04.04 0 00.01.02z"/>';
export var CommunityOutlineSVG = function CommunityOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CommunityOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CommunityOutlineSVG);